import React from "react";
import ImageBuildingCombinations from './ImageBuildingCombinations';
import './ImageBuilding.sass';
import {TravianBuildingTribe} from "../../enum/Tribe";

type Props = {
    gid: number,
    size?: 16|24|32|64|128,
    tribe?: TravianBuildingTribe,
    grayscale?: boolean
}

export default function ImageBuilding({ gid, size, tribe, grayscale }: Props) {
    if (ImageBuildingCombinations[gid] === undefined) {
        return <i className={`travianBuildingImage size-${size ?? 32}`}></i>
    }
    if (tribe === undefined) {
        tribe = TravianBuildingTribe.Neutral;
    }
    if (!ImageBuildingCombinations[gid].includes(tribe)) {
        tribe = ImageBuildingCombinations[gid].sort((a, b) => a - b)[0];
    }
    return <i className={`travianBuildingImage size-${size ?? 32} tribe-${tribe} building_g${gid} ${grayscale ? 'filter-grayscale' : ''}`}></i>
}
